(()=>{
  const root=document.querySelector('[data-ecomminds-main-collection]');
  if(!root||root.dataset.bound)return;
  root.dataset.bound='1';

  const grid=root.querySelector('[data-ecomminds-grid]');
  const count=root.querySelector('[data-ecomminds-count]');
  const mobileCount=root.querySelector('[data-ecomminds-mobile-count]');
  const promoTpl=root.querySelector('[data-ecomminds-promo-template]');
  const drawer=root.querySelector('[data-ecomminds-filter-drawer]');
  const cards=()=>[...grid.querySelectorAll('[data-ecomminds-product]')];

  const syncPromo=()=>{
    grid.querySelectorAll('[data-ecomminds-promo]').forEach(x=>x.remove());
    if(!promoTpl)return;
    const visible=cards().filter(x=>!x.hidden);
    if(visible[1])visible[1].insertAdjacentHTML('afterend',promoTpl.innerHTML);
  };


  const bindMediaSliders=()=>{
    root.querySelectorAll('[data-ecomminds-media]').forEach(media=>{
      if(media.dataset.sliderBound)return;
      media.dataset.sliderBound='1';
      const track=media.querySelector('[data-ecomminds-media-track]');
      const progress=media.querySelector('[data-ecomminds-media-progress]');
      if(!track||!progress)return;

      const update=()=>{
        const max=Math.max(1,track.scrollWidth-track.clientWidth);
        const ratio=Math.max(0,Math.min(1,track.scrollLeft/max));
        progress.style.transform='translateX('+(ratio*100)+'%)';
      };

      track.addEventListener('scroll',()=>{
        requestAnimationFrame(update);
      },{passive:true});

      update();
    });
  };

  const apply=()=>{
    const groups={};
    root.querySelectorAll('[data-filter-group]:checked').forEach(input=>{
      (groups[input.dataset.filterGroup]??=[]).push(input.value);
    });

    cards().forEach(card=>{
      card.hidden=!Object.entries(groups).every(([group,values])=>{
        const haystack=(card.dataset[group]||'').toLowerCase();
        return values.some(value=>haystack.includes(value.toLowerCase()));
      });
    });

    const visible=cards().filter(x=>!x.hidden).length;
    if(count)count.textContent=visible+' Ürün';
    if(mobileCount)mobileCount.textContent=visible+' Ürün';
    syncPromo();
  };

  root.querySelectorAll('[data-ecomminds-toggle]').forEach(button=>{
    button.addEventListener('click',()=>{
      const group=button.closest('.ecomminds-filter-group');
      const open=group.classList.toggle('is-open');
      button.setAttribute('aria-expanded',open?'true':'false');
    });
  });

  root.querySelectorAll('[data-filter-group]').forEach(input=>{
    input.addEventListener('change',apply);
  });

  root.querySelectorAll('input[name=ecomminds_sort]').forEach(input=>{
    input.addEventListener('change',()=>{
      if(input.checked)location.href=location.pathname+'?sort_by='+encodeURIComponent(input.value);
    });
  });

  root.querySelectorAll('[data-ecomminds-mobile-open]').forEach(button=>{
    button.addEventListener('click',()=>{
      drawer?.classList.add('is-mobile-open');
      document.body.classList.add('ecomminds-filter-lock');
    });
  });

  root.querySelectorAll('[data-ecomminds-mobile-close]').forEach(button=>{
    button.addEventListener('click',()=>{
      drawer?.classList.remove('is-mobile-open');
      document.body.classList.remove('ecomminds-filter-lock');
    });
  });

  root.querySelectorAll('[data-ecomminds-clear]').forEach(button=>{
    button.addEventListener('click',()=>{
      root.querySelectorAll('[data-filter-group]').forEach(input=>input.checked=false);
      apply();
    });
  });

  root.querySelectorAll('[data-ecomminds-atc]').forEach(button=>{
    button.addEventListener('click',async event=>{
      if(!window.GlobalCartMain?.addToCart)return;
      event.preventDefault();
      await window.GlobalCartMain.addToCart({items:[{id:Number(button.dataset.variantId),quantity:1}]});
      if(window.globalSideBarUI__cart?.open)window.globalSideBarUI__cart.open();
    });
  });

  bindMediaSliders();
  apply();
})();